// import Partner from '../../../images/MasterPlan/nikel.jpg';
import { animateScroll as scroll } from 'react-scroll';

import styles from './CurrentMasterPlan.module.scss';
import Stage from './Stage/Stage';
import ButtonBack from '../../universal_components/ButtonBack/ButtonBack';

import MapMP from './MapMP/MapMP';
import { getMP } from '../../../requests/getMP';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Photos from './Photos/Photos';
import { getMPIdea } from '../../../requests/getMPIdea';
import { useDispatch, useSelector } from 'react-redux';
import ContentContainer from '../../universal_components/ContentContainer/ContentContainer';
import MainLogo from '../../universal_components/header/mainLogo/MainLogo';
import InfoSection from './InfoSection/InfoSection';

const CurrentMasterPlan = () => {
  const { id } = useParams();
  const [MP, setMP] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pdfLinks, setPdfLinks] = useState([]);

  const MPIdeasRedux = useSelector((state) => state.MPIdeas.ideas);
  const MPs = useSelector((state) => state.MPs.MPs);

  const extractPdfLinks = (data) => {
    if (!data?.documentation?.chapter) return [];

    const links = [];
    data.documentation.chapter.forEach((chapter) => {
      if (chapter.document && Array.isArray(chapter.document)) {
        chapter.document.forEach((doc) => {
          if (doc.doc && doc.doc.trim().toLowerCase().endsWith('.pdf')) {
            links.push({
              title: doc.title,
              url: doc.doc.trim(),
              chapterTitle: chapter.title, // может пригодиться для группировки
            });
          }
        });
      }
    });
    return links;
  };

  useEffect(() => {
    getMP(id).then((data) => {
      setMP(data);
      setPdfLinks(extractPdfLinks(data)); // Устанавливаем PDF ссылки
    });
    dispatch(getMPIdea(id));
    scroll.scrollToTop({ duration: 0 });
  }, [id, dispatch]);

  if (!MP) return <div className={styles.header} />;

  return (
    <>
      <div className={styles.header}>
        <div
          style={{
            backgroundImage: `url("${MP.main_image}")`,
            filter: 'brightness(50%)',
          }}
          className={styles.backgroundImage}
        />

        <div className={styles.logo}>
          <MainLogo onClick={() => navigate('/')} />
        </div>

        <ContentContainer>
          <div className={styles.text}>
            <div className={styles.textWrapper}>
              <div className={styles.title}>
                <h1>{MP.title}</h1>
                <a href={'https://forms.yandex.ru/u/65ade30e84227c9b25d622b9/'} target="_blank" rel="noreferrer">
                  {'Отправить идею'}
                  {/* text */}
                </a>
              </div>
              <div className={styles.docFiles}>
                {pdfLinks.map((link, index) => (
                  <div key={index}>
                    <a className={styles.docLink} href={link.url} target="_blank" rel="noreferrer">
                      {link.title}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </ContentContainer>
      </div>

      {/* Мастер-план */}
      {/* {MP?.documentation?.chapter && <Docs docs={MP.documentation} />} */}
      <ContentContainer>
        <h2 className={styles.MPTitle}>Мастер-план</h2>
      </ContentContainer>

      <Photos photos={MP.gallery} />

      <MapMP ideas={MPIdeasRedux} id={id} />

      <Stage stages={MP.stage} />

      {/* <Results /> */}

      {/* {MP?.participants?.length > 0 && (
        <div className={styles.partners}>
          <img className={styles.partner} src={Partner} />
          <img className={styles.partner} src={Partner} />
          <img className={styles.partner} src={Partner} />
          <img className={styles.partner} src={Partner} />
        </div>
      )} */}

      <InfoSection text={MP.text_1} text2={MP.text_2} photo1={MP.text_photo_1} photo2={MP.text_photo_2} />
      <ContentContainer>
        <div className={styles.backButton}>
          <ButtonBack />
          <ButtonBack to={`/masterplan/${MPs.length == id ? 1 : +id + 1}`} text="Следующий мастер-план" />
        </div>
        <div className={styles.arrowsTexts}>
          <div>Назад</div>
          <div>Следующий мастер-план</div>
        </div>
      </ContentContainer>
    </>
  );
};

export default CurrentMasterPlan;
